// Preselects a dropdown from the URL so apply links land with the right choice made.
// The element's data-param names the query parameter (default "coach"); options declare matches as data-<param>="value".
class CoachPreselect extends HTMLElement {
  connectedCallback() {
    const param = this.dataset.param || 'coach';
    const value = new URLSearchParams(window.location.search).get(param);
    if (!value) return;
    const select = this.querySelector('select');
    const option = select?.querySelector(`option[data-${CSS.escape(param)}="${CSS.escape(value)}"]`);
    if (option) select.value = option.value;
  }
}

if (!customElements.get('coach-preselect')) customElements.define('coach-preselect', CoachPreselect);
